import styled from "styled-components";

export const Title = styled.h1`
  font-family: Raleway;
  font-weight: 700;
  font-size: 40px;
  line-height: 42px;
  text-align: center;
  padding-bottom: 40px;
`;

export const Description = styled.p`
  font-family: Nunito Sans;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  color: #A9A9A9;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DescriptionWithMargin = styled(Description)`
  margin-top: 12px;
}`;